const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchDryers = async ({ limit, offset, query }) => {
  try {
    const response = await fetch(`${API_URL}/dryer/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ limit, offset, query }),
    });
    if (!response.ok) throw new Error('Error al obtener las secadoras');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener las secadoras:', error);
    throw error;
  }
};

export const createDryer = async (dryerData) => {
  try {
    const response = await fetch(`${API_URL}/dryer/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dryerData),
    });
    if (!response.ok) throw new Error('Error al crear la secadora');
    return await response.json();
  } catch (error) {
    console.error('Error al crear la secadora:', error);
    throw error;
  }
};

export const updateDryer = async (dryerId, dryerData) => {
  try {
    const response = await fetch(`${API_URL}/dryer/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: dryerId, data: dryerData }),
    });
    if (!response.ok) throw new Error('Error al actualizar la secadora');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar la secadora:', error);
    throw error;
  }
};

export const deleteDryer = async (dryerId) => {
  try {
    const response = await fetch(`${API_URL}/dryer/delete/${dryerId}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Error al eliminar la secadora');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar la secadora:', error);
    throw error;
  }
};

export const exportDryers = async (query = {}) => {
  try {
    const response = await fetch(`${API_URL}/dryer/export`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query }),
    });
    if (!response.ok) throw new Error('Error al exportar las secadoras');
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error al exportar las secadoras:', error);
    throw error;
  }
};

export const getDryers = async (params) => {
  try {
    const idLavanderia = typeof params === 'object' ? params.idLavanderia : params;
    const response = await fetch(`${API_URL}/dryer/getDryers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: { idLavanderia } }),
    });
    if (!response.ok) throw new Error('Error al obtener las secadoras');
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error al obtener las secadoras:', error);
    throw error;
  }
};

export const updateDryerCounter = async (dryerId, newCounter) => {
  try {
    const response = await fetch(`${API_URL}/dryer/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: dryerId, data: { contador: newCounter } }),
    });
    if (!response.ok) throw new Error('Error al actualizar el contador de la secadora');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar el contador de la secadora:', error);
    throw error;
  }
};
